import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getInfrastructurePhotos(companyId, infrastructureId) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_PHOTOS,dtConfig[ModulesMap.INFRASTRUCTURE_PHOTOS].getInfrastructurePhotos,
		{
			urlParams: {
				companyId: companyId,
				infrastructureId,
			},
		},
	)
}

function createInfrastructurePhoto(companyId, infrastructureId, data) {
	
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_PHOTOS,dtConfig[ModulesMap.INFRASTRUCTURE_PHOTOS].createInfrastructurePhoto,
		{
			urlParams: {
				companyId,
				infrastructureId,
			},
			...data,
		},
	)
}

function getInfrastructurePhoto(companyId, infrastructureId, photosId) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_PHOTOS,dtConfig[ModulesMap.INFRASTRUCTURE_PHOTOS].getInfrastructurePhoto,
		{
			urlParams: {
				companyId,
				infrastructureId,
				photosId,
			},
		},
	)
}

function patchInfrastructurePhoto(companyId, infrastructureId, photosId, data) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_PHOTOS,dtConfig[ModulesMap.INFRASTRUCTURE_PHOTOS].patchInfrastructurePhoto,
		{
			urlParams: {
				companyId,
				infrastructureId,
				photosId,
			},
			...data,
		},
	)
}

function putInfrastructurePhoto(companyId, infrastructureId, photosId, data) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_PHOTOS,dtConfig[ModulesMap.INFRASTRUCTURE_PHOTOS].putInfrastructurePhoto,
		{
			urlParams: {
				companyId,
				infrastructureId,
				photosId,
			},
			...data,
		},
	)
}

function deleteInfrastructurePhoto(companyId, infrastructureId, photosId) {
	return dataTransferWrap(
		ModulesMap.INFRASTRUCTURE_PHOTOS,dtConfig[ModulesMap.INFRASTRUCTURE_PHOTOS].deleteInfrastructurePhoto,
		{
			urlParams: {
				companyId,
				infrastructureId,
				photosId,
			},
		},
	)
}

export default {
	getInfrastructurePhotos,
	getInfrastructurePhoto,
	patchInfrastructurePhoto,
	putInfrastructurePhoto,
	createInfrastructurePhoto,
	deleteInfrastructurePhoto,
}